export const appManagementStrings = {
  user: {
    areaName: 'Nutzerverwaltung',
  },
  groups: {
    areaName: 'Gruppenverwaltung',
  },
  migration: {
    areaName: 'Migrationsfehler',
    total: 'Fehler gesamt',
    byEntityType: 'Fehler je Entität',
    entityLabel: { singular: 'Fehler', plural: 'Fehler' },
    inconsistency: {
      createdAt: 'Zeitpunkt',
      entityType: 'Entität',
      dossier: 'Vorgang',
      sharePointItemId: 'SharePoint-ID',
      errorMessage: 'Fehlermeldung',
    },
  },
  roleAssignment: {
    roleType: 'Rolle',
    objectType: 'Objekttyp',
    dossierId: 'Vorgang-ID',
    selectRole: 'Rolle wählen',
    enterObjectType: 'Objekttyp',
    enterDossierId: 'Vorgang-ID',
    noAssignments: 'Keine Rollenzuweisungen',
    addAssignment: 'Rollenzuweisung hinzufügen',
  },
  roleTypes: {
    none: 'Keine',
    reader: 'Leser',
    contributor: 'Beteiligter',
    editor: 'Bearbeiter',
    administrator: 'Administrator',
  },
  objectTypes: {
    app: 'App',
    dossier: 'Dossier',
  },
  commands: {
    roleAssignment: 'Berechtigungen',
  },
  accessManager: {
    title: 'Zugriff verwalten',
    userAssignments: 'Benutzerzuweisungen',
    groupAssignments: 'Gruppenzuweisungen',
    assignedUsers: 'Zugewiesene Benutzer',
    assignedGroups: 'Zugewiesene Gruppen',
    searchUsers: 'Benutzer suchen...',
    searchGroups: 'Gruppen suchen...',
    loadMore: 'Mehr laden',
    saveChanges: 'Änderungen speichern',
    loading: 'Lädt...',
    errorLoading: 'Fehler beim Laden der Rollenzuweisungen',
    errorSaving: 'Fehler beim Speichern der Rollenzuweisungen',
    saveSuccess: 'Rollenzuweisungen erfolgreich gespeichert',
  },
  templates: {
    areaName: 'Dokumentvorlagen',
    name: 'Vorlage',
    modifiedAt: 'Zuletzt geändert',
    actions: 'Aktionen',
    download: 'Herunterladen',
    statusDefault: 'Standard',
    downloadError: 'Fehler beim Herunterladen der Vorlage',
  },
};
